module.exports = __webpack_public_path__ + "img/manager1.57c5daa3.jpg";